import React from 'react';

export default (Component, invitations, comment, onUpdate) => ((props) => (<Component invitations={invitations} comment={comment} onUpdate={onUpdate} {...props} />));
